import type { MouseEvent, ReactElement } from 'react';

import { GameCommunicationBetSender } from '../../../../controllers/gameCommunication/senders/GameCommunicationBetSender';
import { Logger } from '../../../../logger/Logger';
import { useCoreDispatch } from '../../../../store/CoreStore';
import { useBetSlice } from '../../../../store/slices/bets/selectors';
import { betActions } from '../../../../store/slices/bets/slice';
import { useGameStateSlice } from '../../../../store/slices/game/selectors';
import { type GameButtonProps, GameButtonWithTooltip } from '../../../game/gameButton/gameButton';
import { Icons } from '../../../icons/iconNames';

const betSender = new GameCommunicationBetSender();

export interface UndoControlConnectedProps extends Omit<GameButtonProps, 'icon'> {}

export const UndoControlConnected = ({ disabled, onClick, ...rest }: UndoControlConnectedProps): ReactElement => {
  const dispatch = useCoreDispatch();

  const bets = useBetSlice.bets();
  const isBetsOpenStatus = useGameStateSlice.isBetsOpenStatus();

  const handleUndo = (event: MouseEvent<HTMLButtonElement>): void => {
    dispatch(betActions.popBet());
    Logger.logEvent('click', 'undo', Date.now(), 1, '', false);
    betSender.dispatch();
    onClick?.(event);
  };

  const isDisabled = disabled || !bets || !isBetsOpenStatus;

  return (
    <GameButtonWithTooltip
      data-testid="undo-button"
      border
      disabled={isDisabled}
      icon={Icons.Undo}
      onClick={handleUndo}
      sound="undoClick"
      tooltipOptions={{
        disabled: isDisabled,
        text: 'UNDO',
      }}
      {...rest}
    />
  );
};
